// extracted by mini-css-extract-plugin
module.exports = {"page":"Bp5hCb7S","bodyContainer":"_3tqCl2XN","title":"_3PByMbPd","titleText":"_2yz7LUlj","sideBarDivider":"_1LMogFAA"};